import { Link, useLocation, useNavigate } from "react-router-dom";
import { Inbox, ShoppingBag, Wallet, PenLine, LogOut, RefreshCcw, Radio } from "lucide-react";
import { BRAND } from "../config/site";
import { ADMIN_KEY } from "../pages/AdminLogin";

const LINKS = [
  { to: "/admin/requests", l: "Richieste", icon: Inbox },
  { to: "/admin/ordini", l: "Ordini", icon: ShoppingBag },
  { to: "/admin/pagamenti", l: "Pagamenti", icon: Wallet },
  { to: "/admin/diretta", l: "Diretta", icon: Radio },
  { to: "/admin/contenuti", l: "Testi & prezzi", icon: PenLine },
];

// Barra unica del pannello creator
export const AdminNav = ({ onRefresh, badge }) => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const logout = () => { localStorage.removeItem(ADMIN_KEY); nav("/admin"); };
  return (
    <header className="sticky top-0 z-30 border-b border-[rgba(0,175,240,0.14)] bg-[#0b0b0d]/95 backdrop-blur" data-testid="admin-nav">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-5 sm:px-8">
        <Link to="/" className="flex shrink-0 items-baseline gap-2" data-testid="admin-home-link">
          <span className="text-gold-sheen font-display text-2xl italic">{BRAND.short}</span>
          <span className="hidden text-[10px] uppercase tracking-[0.3em] text-[#b9b2aa] sm:inline">Admin</span>
        </Link>
        <nav className="flex min-w-0 flex-1 justify-center gap-1 overflow-x-auto">
          {LINKS.map((x) => {
            const on = pathname === x.to;
            return (
              <Link key={x.to} to={x.to} data-testid={`admin-nav-${x.to.split("/").pop()}`} className={`relative flex min-h-[40px] shrink-0 items-center gap-1.5 rounded-full px-3 text-[11px] uppercase tracking-[0.14em] ${on ? "btn-gold font-semibold" : "text-[#b9b2aa] hover:text-[#f5f2ee]"}`}>
                <x.icon className="h-3.5 w-3.5" /> <span className="hidden sm:inline">{x.l}</span>
                {x.to === "/admin/ordini" && Number(badge) > 0 && <span className="ml-1 rounded-full bg-[color:var(--rose)] px-1.5 text-[9px] font-bold text-[#0b0b0d]" data-testid="admin-orders-badge">{badge}</span>}
              </Link>
            );
          })}
        </nav>
        <div className="flex shrink-0 gap-2">
          {onRefresh && <button data-testid="admin-refresh-button" onClick={onRefresh} className="btn-ghost-lux flex h-10 w-10 items-center justify-center rounded-full" aria-label="Aggiorna"><RefreshCcw className="h-4 w-4" /></button>}
          <button data-testid="admin-logout-button" onClick={logout} className="btn-ghost-lux flex h-10 items-center gap-2 rounded-full px-3 text-[11px] uppercase tracking-[0.14em]"><LogOut className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Esci</span></button>
        </div>
      </div>
    </header>
  );
};

export const useAdminAuth = () => {
  const nav = useNavigate();
  const token = localStorage.getItem(ADMIN_KEY);
  const headers = { Authorization: `Bearer ${token}` };
  const handle = (e) => {
    if (e?.response?.status === 401) { localStorage.removeItem(ADMIN_KEY); nav("/admin"); return true; }
    return false;
  };
  return { token, headers, handle, nav };
};
